export default __webpack_public_path__ + "static/media/poi-icon.9547039d.svg";